package ui.campaign.detailv2.editor.wrapper

import api.ResourceType
import common.frontend.api.Io
import org.ssoft.common.type.ScreenRatio
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.layer_top_detail_editor__err_missing_visual
import ssoft.frontend.generated.resources.layer_top_detail_editor__err_visual_duration
import tools.await

class CampaignWrapperEVisual(
    companyId: Long,
    campaign: Io.Campaign,
    devicesScreenRatio: () -> List<ScreenRatio>
) : ImplCampaignWrapperEVisual(
    companyId = companyId,
    campaign = campaign,
    groups = listOf(campaign.visuals.firstOrNull { it.isPrimary } ?: Io.Campaign.VisualGroup.EMPTY.copy(isPrimary = true)),
    devicesScreenRatio = devicesScreenRatio
) {
    val adapterVisuals get() = group.state.first().visuals

    private val deviceMatch get() = adapterVisuals.state.filter { it.data.mask in deviceRatioMasks }


    override val err: Boolean
        get() = deviceMatch.any { it.invalidVisualDuration } ||
                deviceMatch.any { it.resource == null }

    override suspend fun extractErr(): String? {
        return if (!err) null
        else buildString {
            if (deviceMatch.any { it.invalidVisualDuration }) appendLine(Res.string.layer_top_detail_editor__err_visual_duration.await())
            if (deviceMatch.any { it.resource == null }) appendLine(Res.string.layer_top_detail_editor__err_missing_visual.await())

        }.trim().takeIf { it.isNotEmpty() }
    }

    override fun extract(): List<Io.Campaign.VisualGroup> {
        return listOf(
            group.state.first().data.copy(
                res = deviceMatch
                    .mapNotNull { it.resource }
                    .onEach {
                        if (ResourceType.IMAGE match it.type) {
                            it.duration = campaign.settings.campaignDuration
                        }
                    }
                    .toMutableList()
            )
        )
    }
}